module.exports = __webpack_public_path__ + "static/media/ApplyChangesInactive.cc702a86.png";